import { Component, Input, Output, EventEmitter } from '@angular/core';
@Component({
  selector: 'app-scrolldiv',
  templateUrl: './scrolldiv.component.html',
  styleUrls: ['./scrolldiv.component.scss']
})
export class ScrolldivComponent {
  @Output() scrollLeft = new EventEmitter<void>();
  @Output() scrollRight = new EventEmitter<void>();

  onScrollLeft() {
    this.scrollLeft.emit(); 
  }

  onScrollRight() {
    this.scrollRight.emit();
  }

}
